export enum AvailabilityType {
  AllDay,
  Hours,
}
